import { IconProps } from '@/models/appState';
import React from 'react';

interface TabButtonProps {
    id: string;
    label: React.ReactNode;
    count?: number;
    Icon?: React.ComponentType<any>;
    active?: boolean;
    variant?: 'primary' | 'approval';
    onClick?: () => void;
    tabIndex?: number;
    iconProps?: IconProps;
}

const TabButton: React.FC<TabButtonProps> = ({
    id,
    label,
    count,
    Icon,
    active,
    variant = 'primary',
    onClick,
    tabIndex,
    iconProps,
}) => {
    const activeClass = active
        ? (variant === 'approval'
            ? 'bg-amber-500 text-white border-amber-500 shadow-md scale-105'
            : 'bg-blue-600 text-white border-blue-600 shadow-md scale-105')
        : (variant === 'approval'
            ? 'bg-white text-amber-700 border-amber-200 hover:bg-amber-100 hover:border-amber-300'
            : 'bg-white text-blue-700 border-blue-200 hover:bg-blue-100 hover:border-blue-400');

    const style: React.CSSProperties = active ? { boxShadow: variant === 'approval' ? '0 2px 8px 0 #f59e0b22' : '0 2px 8px 0 #2563eb22' } : {};
    const extendedIconProps = active && iconProps?.activeColor ? { ...iconProps, color: iconProps.activeColor } : iconProps;

    return (
        <button
            key={id}
            className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold border focus:outline-none transition-all duration-150 whitespace-nowrap ${activeClass}`}
            style={style}
            onClick={onClick}
            tabIndex={tabIndex}
        >
            {Icon && <Icon className="h-4 w-4 flex-shrink-0" {...(extendedIconProps)} />}
            <span>{label}</span>
            {typeof count === 'number' && <span className="ml-0.5 sm:ml-1 font-bold flex-shrink-0">{count}</span>}
        </button>
    );
};

export default TabButton;
